const masteringDE = {
    "view": {
        "table": {
            "title": "Ihre Mastering-Liste",
            "column": {
                "created_by": "Erstellt von",
                "total_songs": "Anzahl der Lieder",
                "mastered_songs": "Gesamtanzahl der gemasterten Lieder",
                "created": "Erstellungsdatum",
                "action": "Aktion"
            },
            "button": {
                "open": "ÖFFNEN",
                "edit": "BEARBEITEN",
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            }
        },
        "message": {
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "noCredits": "Sie haben keine Audiomastering-Credits mehr. Erfahren Sie mehr über Credits <1>hier</1> und wenden Sie sich bitte an unser Support-Team.",
            "learnMore": "Erfahren Sie alles über Audio Mastering <1>hier</1>. Für weitere Informationen und <3>Credits</3> wenden Sie sich bitte an unser Support-Team."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "Wie viele Lieder möchten Sie mastern?",
                "label": {
                    "number_of_songs": "Anzahl der Lieder"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Anzahl der Lieder auswählen",
                        "song": "Lied",
                        "songs": "Lieder"
                    }
                },
                "button": {
                    "continue": "Weiter"
                }
            },
            "step2": {
                "title": "Wählen Sie Ihre Lieder zum Mastern aus",
                "button": {
                    "save": "Speichern"
                }
            }
        },
        "message": {
            "uploadSuccess": "Audio Mastering Lieder erfolgreich hochgeladen!",
            "creationSuccess": "Audio Mastering wurde erstellt! Bitte wählen Sie nun Ihre Lieder im untenstehenden Abschnitt aus.",
            "error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
        },
        "modal": {
            "addMastering": {
                "header": "Sind Sie sicher, dass Sie ein neues Mastering hinzufügen möchten?",
                "body": "Hinweis: Dies führt zu einem Abzug von {{credits}} Credits."
            },
            "saveMastering": {
                "header": "Sind Sie sicher, dass Sie das Audio Mastering speichern möchten?",
                "body": "Hinweis: Bitte stellen Sie sicher, dass Sie die richtigen Audiodateien hochladen, da sie nach dem Speichern nicht mehr geändert werden können."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Wählen Sie Ihre Lieder zum Mastern aus"
            },
            "button": {
                "save": "Speichern"
            }
        },
        "message": {
            "success": "Audio Mastering erfolgreich aktualisiert!",
            "errorCantUpdate": "Audio Mastering kann nicht aktualisiert werden, sobald die Lieder hochgeladen sind!",
            "errorMasteringDoesNotExist": "Mastering kann nicht aktualisiert werden, da es nicht existiert!",
            "error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
        },
        "modal": {
            "saveMastering": {
                "header": "Sind Sie sicher, dass Sie das Audio Mastering speichern möchten?",
                "body": "Hinweis: Bitte stellen Sie sicher, dass Sie die richtigen Audiodateien hochladen, da sie nach dem Speichern nicht mehr geändert werden können."
            }
        }
    },
    "viewSongs": {
        "title": "Audio Mastering Lieder",
        "table": {
            "column": {
                "name": "Name",
                "preset": "Voreinstellung",
                "intensityAndLoudness": "Intensität & Lautstärke",
                "preview": "Vorschau",
                "master": "Master",
                "previewResult": "Vorschauergebnis",
                "masteringResult": "Masteringergebnis",
                "mastered": "Gemastert",
                "action": "Aktion"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} übrig",
                "notAvailable": "Nicht verfügbar"
            },
            "button": {
                "generate": "Erzeugen",
                "edit": "Bearbeiten",
                "exportCsv": "CSV exportieren"
            },
            "option": {
                "preset": {
                    "acoustic": "Akustisch",
                    "allGenres": "Alle Genres",
                    "classical": "Klassisch",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "EDM Musik",
                    "electronic": "Elektronisch",
                    "electronicRaw": "Elektronisch Roh",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Pop Musik",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Vokal fokussiert"
                }
            },
            "message": {
                "previewDownloadTooltip": "Die Vorschau wird erstellt. Bitte erlauben Sie 5-6 Minuten, bis sie erscheint.",
                "masteringDownloadTooltip": "Das Mastering ist in Bearbeitung. Bitte erlauben Sie 7-15 Minuten, bis es erscheint.",
                "alreadyMasteredTooltip": "Dieses Lied ist bereits gemastert."
            }
        },
        "message": {
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "successMaster": "Lied zur Mastering-Erstellung gesendet!<br/>Hinweis: Bitte in ein paar Minuten nachsehen, da es 7-15 Minuten dauert, um das Mastering zu erstellen.",
            "successPreview": "Lied zur Mastering-Vorschau-Erstellung gesendet!<br/>Hinweis: Bitte in ein paar Minuten nachsehen, da es 5-6 Minuten dauert, um die Mastering-Vorschau zu erstellen."
        },
        "modal": {
            "generateMastering": {
                "header": "Mastering erzeugen",
                "body": "Sind Sie sicher, dass Sie das Mastering erzeugen möchten? Dies ist eine irreversible Aktion! Das Master-Ergebnis wird innerhalb von 7-15 Minuten erscheinen.",
                "message": {
                    "success": "Lied zur Mastering-Erstellung gesendet!"
                }
            },
            "generateMasteringPreview": {
                "header": "Mastering-Vorschau erzeugen",
                "body": "Sind Sie sicher, dass Sie die Mastering-Vorschau erzeugen möchten? Das Vorschauergebnis wird innerhalb von 5-6 Minuten erscheinen",
                "message": {
                    "success": "Lied zur Mastering-Vorschau-Erstellung gesendet!"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Liedparameter bearbeiten",
        "form": {
            "label": {
                "intensity": "Intensität",
                "loudness": "Lautstärke",
                "preset": "Voreinstellung"
            },
            "placeholder": {
                "preset": "Voreinstellung auswählen"
            },
            "option": {
                "preset": {
                    "acoustic": "Akustisch",
                    "allGenres": "Alle Genres",
                    "classical": "Klassisch",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "EDM Musik",
                    "electronic": "Elektronisch",
                    "electronicRaw": "Elektronisch Roh",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Pop Musik",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Vokal fokussiert"
                }
            },
            "button": {
                "submit": "Einreichen"
            },
            "message": {
                "intensityTooltip": "Die Menge an Dynamik, EQ und Verarbeitung, die auf Ihr Lied in Bezug auf den gesamten Track und die ausgewählte Voreinstellung angewendet wird. Maximale Nutzung erfolgt bei 100 %. Wir empfehlen, mit dieser Einstellung zu experimentieren, um den Sweet Spot zu finden, der am besten zu Ihnen passt.",
                "loudnessTooltip": "Das integrierte Lautstärke-Zielniveau. Gemessen in Lautstärke-Einheiten relativ zur Vollskala (LUFS).​ Wir empfehlen, mit dieser Einstellung zu experimentieren, um den Sweet Spot zu finden, der am besten zu Ihnen passt.​ Je nach Stil und Genre Ihres Liedes sollten die besten Ergebnisse bei -15 bis -9 db erscheinen."
            }
        },
        "message": {
            "success": "Liedparameter wurden aktualisiert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "songMastered": "Liedparameter können nicht aktualisiert werden, sobald das Lied gemastert wurde!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Lieder",
            "name": "Name",
            "genre": "Genre",
            "preset": "Voreinstellung",
            "intensity": "Intensität",
            "loudness": "Lautstärke",
            "audioFile": "Audiodatei"
        },
        "placeholder": {
            "name": "z.B. Liedname",
            "genre": "z.B. Pop",
            "preset": "Voreinstellung auswählen"
        },
        "option": {
            "preset": {
                "acoustic": "Akustisch",
                "allGenres": "Alle Genres",
                "classical": "Klassisch",
                "clubHouseTechno": "Club - House - Techno",
                "edmMusic": "EDM Musik",
                "electronic": "Elektronisch",
                "electronicRaw": "Elektronisch Roh",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Pop Musik",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Vokal fokussiert"
            }
        },
        "message": {
            "intensityTooltip": "Die Menge an Dynamik, EQ und Verarbeitung, die auf Ihr Lied in Bezug auf den gesamten Track und die ausgewählte Voreinstellung angewendet wird. Maximale Nutzung erfolgt bei 100 %. Wir empfehlen, mit dieser Einstellung zu experimentieren, um den Sweet Spot zu finden, der am besten zu Ihnen passt.",
            "loudnessTooltip": "Das integrierte Lautstärke-Zielniveau. Gemessen in Lautstärke-Einheiten relativ zur Vollskala (LUFS).​ Wir empfehlen, mit dieser Einstellung zu experimentieren, um den Sweet Spot zu finden, der am besten zu Ihnen passt.​ Je nach Stil und Genre Ihres Liedes sollten die besten Ergebnisse bei -15 bis -9 db erscheinen.",
            "audioFileTooltip": "Unterstützte Audioformate sind: AAC, AIFF, FLAC, MP3, OPUS, VORBIS und WAV. Wir empfehlen dringend, verlustfreie Dateitypen wie AIFF, FLAC oder WAV zu verwenden. Unser Mastering-Tool gibt immer denselben Dateityp wie die Originaldatei zurück. Beachten Sie, dass Sie eine 16-Bit, 44,1 kHz WAV-Datei für die Verteilung benötigen.",
            "errorSongNameRequired": "Bitte geben Sie den Liednamen ein",
            "errorSongNameLength": "Der Liedname sollte nicht mehr als 80 Zeichen haben.",
            "errorGenreRequired": "Bitte geben Sie das Liedgenre ein",
            "errorGenreLength": "Das Liedgenre sollte nicht mehr als 50 Zeichen haben.",
            "errorPresetRequired": "Voreinstellung sollte ausgewählt werden.",
            "errorAudioFileRequired": "Bitte wählen Sie eine Lieddatei aus",
            "errorAudioFileValid": "Bitte laden Sie eine gültige Audiodatei hoch"
        }
    },
    "masteringConfirmModal": {
        "header": "Sind Sie sicher, dass Sie das Audio Mastering speichern möchten?",
        "body": "Hinweis: Bitte stellen Sie sicher, dass Sie die richtigen Audiodateien hochladen, da sie nach dem Speichern nicht mehr geändert werden können.",
        "button": {
            "cancel": "Abbrechen",
            "confirm": "Bestätigen"
        },
        "message": {
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        }
    }
};

export default masteringDE;